var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-box rounded"},[_c('LogoAbx',{staticClass:"logo-abx"}),_c('span',{staticClass:"text-nowrap"},[_vm._v("HIN: "+_vm._s(_vm.hin))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }